import React from "react";
import PropTypes from "prop-types";

import formatPublishedDate from "utils/formatPublishedDate";
import { MicrodataContext } from "config/contexts";

import styles from "./PubDate.css";

export default function PubDate({ story }) {
  // *every* story in published in *Prod* should have a derived
  // `first_published` attr, however in Dev we can fall back on `published_date`
  const publishDate = story.first_published || story.published_date;
  const displayPublishDate = formatPublishedDate(
    publishDate,
    story.status,
    true
  );
  const displayUpdatedDate =
    story.last_published &&
    formatPublishedDate(story.last_published, story.status, true);
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <span className={styles.root}>
          <time
            itemProp={microdata ? "datePublished" : undefined}
            title={formatPublishedDate(publishDate, story.status, true)}
            dateTime={publishDate}
          >
            {displayPublishDate}
          </time>
          {story.last_published && story.last_published !== publishDate ? (
            <time
              itemProp={microdata ? "dateUpdated" : undefined}
              title={formatPublishedDate(
                story.last_published,
                story.status,
                true
              )}
              dateTime={story.last_published}
            >
              | updated{" "}
              {displayUpdatedDate !== displayPublishDate
                ? displayUpdatedDate
                : ""}
            </time>
          ) : null}
        </span>
      )}
    </MicrodataContext.Consumer>
  );
}

PubDate.propTypes = {
  story: PropTypes.shape({
    first_published: PropTypes.string,
    last_published: PropTypes.string,
    published_date: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};
